module.exports = __webpack_public_path__ + "img/ninja2.3a742c54.png";